module.exports = __webpack_public_path__ + "public/SideMenuIcons/managePromoCode.svg?b9843a28";